import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=aab70e98&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aab70e98')) {
      api.createRecord('aab70e98', component.options)
    } else {
      api.reload('aab70e98', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=aab70e98&", function () {
      api.rerender('aab70e98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20n1FVUAtIkjU/JS/comp/ImgFallback.vue"
export default component.exports